import { v } from './version';

export const environment = {
  production: true,
};
export const ENV = 'test';
export const VERSION = v;
export const NOMBRE_APP = 'Admin';
// Apis
export const apiAdmin = 'https://apis2.novit.gpesistemas.ar/admin-test';
// socket.io (nuevo bridge seguridad-api-websocket-io). Para la migración:
// io(socketIoServer, { path: socketIoPath }).
export const socketIoServer = 'https://apis2.novit.gpesistemas.ar';
export const socketIoPath = '/socket-io-test/socket.io';

// Mapbox
export const MAPBOX_TOKEN =
  'pk.eyJ1IjoiZXplcXVpZWxmYWxjb24iLCJhIjoiY2w0ZzF3d2s2MDJncjNjbzlhY3ppNDR4aSJ9.HbxnFpCClbHL5SOCI9BgSw';
